export const light = {
  body: "hsl(0,0%,100%)",
  text: "hsl(0,0%,0%)",
  element: "hsl(0,0%,0%)",
  elementText: "hsl(0,0%,100%)",
  elementSubtle: "hsl(0,0%,15%)",
  subtle: "hsl(0,0%,89%)",
  textSecondary: "hsl(0,0%,45%)",
  disabled: 'hsl(0,0%,45%',
  overlay: 'hsla(0,0%,0%,0.15)',
  overlayDarker: 'hsla(0,0%,0%,0.3)',
}

export const dark = {
  body: "hsl(0,0%,5%)",
  text: "hsl(0,0%,95%)",
  element: "hsl(0,0%,100%)",
  elementText: "hsl(0,0%,0%)",
  elementSubtle: "hsl(0,0%,89%)",
  subtle: "hsl(0,0%,15%)",
  textSecondary: "hsl(0,0%,65%)",
  disabled: 'hsl(0,0%,45%',
  overlay: 'hsla(0,0%,100%,0.1)',
  overlayDarker: 'hsla(0,0%,100%,0.3)'
}